import React from "react";
import styled from "styled-components";

const Card = styled.div`
    background:white;
    border-radius:18px;
    padding:24px;
    box-shadow:0 8px 25px rgba(0,0,0,.08);
`;

const Header = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:12px;
    flex-wrap:wrap;
    margin-bottom:12px;
`;

const Title = styled.h3`
    margin:0;
`;

const Button = styled.button`
    padding:10px 18px;
    border:none;
    border-radius:10px;
    cursor:pointer;
    background:#2563eb;
    color:white;
    font-weight:bold;
`;

const Grupo = styled.button`
    width:100%;
    text-align:left;
    background:none;
    border:0;
    border-top:1px solid #eee;
    padding:14px 4px;
    cursor:pointer;
    font:inherit;
    color:inherit;
    display:flex;
    justify-content:space-between;
    align-items:center;
    gap:12px;

    &:hover{ background:#f9fafb; }
`;

const Detalle = styled.small`
    display:block;
    color:#666;
    margin-top:4px;
`;

const Rol = styled.span`
    font-size:12px;
    font-weight:600;
    padding:3px 10px;
    border-radius:999px;
    white-space:nowrap;
    background:${({ $admin }) => ($admin ? "#e8f0f6" : "#f3f4f6")};
    color:${({ $admin }) => ($admin ? "#23577a" : "#5f6b7a")};
`;

export default function GruposProfesorCard({ grupos, onCrearGrupo, onVerGrupos }) {
    return (
        <Card>
            <Header>
                <Title>👥 Mis grupos</Title>
                <Button onClick={onCrearGrupo}>+ Crear grupo</Button>
            </Header>

            {grupos.length === 0 ? (
                <p>Todavía no tienes grupos. Crea uno e invita a tus estudiantes con un enlace.</p>
            ) : (
                grupos.slice(0, 5).map((grupo) => (
                    <Grupo key={grupo.id} type="button" onClick={() => onVerGrupos(grupo.id)}>
                        <div>
                            <b>{grupo.nombre}</b>
                            {grupo.descripcion && <Detalle>{grupo.descripcion}</Detalle>}
                            {grupo.examenes?.length > 0 && <Detalle>{grupo.examenes.join(", ")}</Detalle>}
                        </div>
                        <Rol $admin={grupo.esAdmin}>{grupo.esAdmin ? "Administrador" : "Profesor"}</Rol>
                    </Grupo>
                ))
            )}

            <div style={{ marginTop: 20, textAlign: "right" }}>
                <Button onClick={() => onVerGrupos()}>Invitar y administrar grupos</Button>
            </div>
        </Card>
    );
}